'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, use } from 'react';
import { ViverseWorldCardType, WorldCardInfo } from '@/types/viverse-world-card';
export type WorldCardContextValue = {
  // Derived / resolved values
  targetUrl: string;
  imageAlt: string;
  cardType: ViverseWorldCardType;
  resolvedImage: string;
  showPremiumTag: boolean;
  isVOD: boolean;
  vodId?: string;
  // Props forwarded as-is
  href?: string;
  imageClassName?: string;
  mediaClassName?: string;
  imageSizes?: string;
  priority?: boolean;
  noAccess?: boolean;
  customDesc?: string;
  moreActionContent?: ReactNode;
  hideLiked: boolean;
  isCoOwnedRoom: boolean;
  showMoreAction: boolean;
  shareOnly: boolean;
  stopSetAsFeatured: boolean;
  onAfterMutatingWorld?: (deleteRoomId?: string) => void;
  // Full info object (needed by MoreAction + useLikedRoom)
  info: WorldCardInfo;
  isClient: boolean;
  // Layout / display flags (owned by ViverseWorldCard, read by Default)
  disableAutoPreview: boolean;
  ranking: boolean;
  rankingIndex?: number;
  cardOnly: boolean;
  isMission: boolean;
  isNew: boolean;
  isUpdated: boolean;
  isExclusive: boolean;
  isSelected: boolean;
  isHot: boolean;
  isTop: boolean;
  isLive: boolean;
  openLinksInNewTab?: boolean;
  banner?: {
    description?: string;
    ctaHref?: string;
    ctaLabel?: string;
    ctaHref2?: string;
    ctaLabel2?: string;
    isHovered?: boolean;
  };
};
const ViverseWorldCardContext = createContext<WorldCardContextValue | null>(null);
export function WorldCardProvider(t0) {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <ViverseWorldCardContext.Provider value={value}>{children}</ViverseWorldCardContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useWorldCardContext(): WorldCardContextValue {
  const ctx = use(ViverseWorldCardContext);
  if (!ctx) throw new Error('useWorldCardContext must be used inside a WorldCardProvider');
  return ctx;
}